import React, {Component} from 'react';
import './App.css';
import AppLayout from "./components/app-layout/AppLayout";
import Authenticator from "./components/authenticator/Authenticator";
import Navigation from "./components/navigation/Navigation"
import RoleAssignment from "./routes/roleAssignment/RoleAssignment"
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Instructor from "./routes/instructor/Instructor";
import CityControlPanel from "./routes/city-control-panel/CityControlPanel";
import { library } from '@fortawesome/fontawesome-svg-core'
// import { fab, fas } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import ErrorBoundary from './components/error-boundary/ErrorBoundary';


library.add(fas)


class App extends Component {
    state = {
        loading: true,
    };

    componentDidMount = () => {
      setTimeout(() => {
          this.setState(() =>({loading: false}));
      }, 2400)
    };

    render() {

        return (
            <AppLayout>
                {/* <AppLoader display={this.state.loading}/> */}
                <Router>
                    <Switch location={window.location}>
                        <Route exact path="/" component={Authenticator}/>
                        <Route exact path="/assign" component={RoleAssignment}/>
                        <Route exact path="/assign/:student_name/:student_email/:game_code/" component={RoleAssignment}/>
                        <Route exact path="/assign/:student_name/:student_email/:game_code/:loc" component={RoleAssignment}/>
                        <Route exact path="/game" component={Navigation}/>
                        <Route exact path="/game/city" component={Navigation}/>
                        <Route exact path="/game/district" component={Navigation}/> 
                        <Route exact path="/game/district/:districtName" component={Navigation}/>
                        <Route exact path="/game/district/:districtName/:category" component={Navigation}/>
                        <Route exact path="/game/district/:districtName/:category/:subPolicy" component={Navigation}/>
                        <Route exact path="/instructor" component={Instructor}/>
                        {/* <Route exact path="/info" component={InfoContainer}/> */}
                        <Route path="/instructor/city/" component={CityControlPanel}/>
                    </Switch>
                </Router>
                
            </AppLayout>
        );
    }
}

export default App;
